var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page page"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('views.admin.title'))+" ")]),_c('AdminHomeComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }